export const environment = {
    production: true,
    staging   : true,
    hmr       : false,
    name      : 'staging',
    url       : 'https://api.appchibarrogrei.com.br/',
    enableHotjarTracking: false,
};
